import Nav from "@components/common/Nav";
import Pages from "@components/common/Pages";
import Components from "@components/Compoents";
import Popups from "@components/popups/Popups";
import ApiProxy from "@ts/ApiProxy";
import GS from "@ts/GlobalSetting";
import LoginProxy from "@ts/LoginProxy";
import { ScrollListener } from "@ts/sframe/ScrollListener";
import Utility from "@ts/sframe/Utility";
import ViewportRoot from "@ts/sframe/ViewportRoot";
import Tools from "@ts/Tools";
import common_page_data_schema from "@schema/common/common-page-data.json";
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import AjvProxy from "./ts/AjvProxy";

gsap.registerPlugin(ScrollToPlugin);

const self: any = {
  init: () => {
    GS.init();
    let prefix = GS.setting.testEnv ? "" : "/";
    $(`#shared-popups`).load(prefix + "shared-popups.html", (responseTxt, statusTxt, xhr) => {
      self.build();
    });
  },
  build: function () {
    AjvProxy.init();
    ApiProxy.setApiPath(GS.setting.apiPath);
    ApiProxy.setApiExtension(GS.setting.apiExt);
    if (GS.setting.testEnv)
      ApiProxy.setSimplateDelay(500);
    window.EZ = {};
    Tools.init();
    Tools.completeLinks($('body'));

    window.addEventListener("resize", () => {
      ViewportRoot.update();
    });
    if ($("body").attr("page") !== "about-supplier") ApiProxy.validatePageData("common-page-data", common_page_data_schema);
    if (GS.setting.testEnv && Utility.urlParams["is-logout"] === "1")
      ApiProxy.getCommonPageData().login_state.is_login = false;
    GS.ezpointRatio.pointToCash = ApiProxy.getCommonPageData().ez_point_ratio.point_to_cash;
    GS.ezpointRatio.priceToPoint = ApiProxy.getCommonPageData().ez_point_ratio.price_to_point;

    if (self.preInitPage)
      self.preInitPage();

    Components.init();

    Nav.init();
    Pages.init();
    Popups.init();
    LoginProxy.init();
    if (self.initPage)
      self.initPage();
    ScrollListener.active();
    ViewportRoot.emitter.addListener("updated", () => {
      ScrollListener.update();
    });
    ViewportRoot.update();
    $('[lazy-loading="pending"]').attr("lazy-loading", "done");
  },
  preInitPage: null,
  initPage: null
};

window.addEventListener('load', () => {
  self.init();
});
export default self;
